import React from "react";

export function Four04(props) {
    return (
        <div className={"wrapper center four04"}>
            <h3>Sorry that page cannot be found</h3>
        </div>
    )
}
